var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home"}},[_c('div',[_c('HorizontalContainer',[(_vm.loggedIn)?_c('TheApp'):_c('LoginForm'),_c('FullscreenSpinner')],1),(_vm.loggedIn)?_c('MessengerPanel'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }